export const requestTypes = [
    { type: 'Emergency Needs', type_value: 'emergency_needs' },
    { type: 'Need to talk', type_value: 'need_to_talk' },
    { type: 'Need to shop', type_value: 'need_to_shop' },
    { type: 'Need a ride', type_value: 'need_a_ride' },
    { type: 'Housing', type_value: 'housing' },
    { type: 'Vital Documents', type_value: 'vital_documents' },
]